import React, { Component } from "react";
import { IndexLink, Link } from "react-router";

$('.training-link-trigger').hover(
	() => {
		window.trainingLinksHover = true;
	},
	() => {
		window.trainingLinksHover = false;
	}
);

export default class Menu extends Component {
	constructor(props) {
		super(props);
		this.state = {
			trainingLinksActive: false
		};

		this.activateTrainingLinks = this.activateTrainingLinks.bind(this);
		this.deactivateTrainingLinksMouse = this.deactivateTrainingLinksMouse.bind(this);
		this.deactivateTrainingLinksBlur = this.deactivateTrainingLinksBlur.bind(this);
	}

	toggleSidebar() {
		document.getElementsByTagName("body")[0].classList.toggle("open-sidebar");
	}

	activateTrainingLinks() {
		this.setState({trainingLinksActive: true});
	}

	deactivateTrainingLinksBlur(e) {
		if (!e.relatedTarget || !e.relatedTarget.classList.contains('training-link-trigger')) {
			this.setState({trainingLinksActive: false});
		}
	}

	deactivateTrainingLinksMouse(e) {
		if (!document.activeElement.classList.contains('training-link-trigger')) {
			if (!window.trainingLinksHover) {
				this.setState({trainingLinksActive: false});
			}
		}
	}

	render() {
		return (
			<nav className="open">
				<IndexLink to="/">
					<img src="/assets/images/Logo%20SVG.svg"/>
				</IndexLink>
				<button className="hamburger" onClick={this.toggleSidebar}>
					<div></div>
				</button>
				<div className="nav-links">
					<IndexLink to="/contact">Contact</IndexLink>
					<div className="training-links">
						<button className="training-link-trigger" onFocus={this.activateTrainingLinks} onBlur={this.deactivateTrainingLinksBlur} onMouseOver={this.activateTrainingLinks} onMouseOut={this.deactivateTrainingLinksMouse}>Training</button>
						<IndexLink className={"training-link-trigger " + (this.state.trainingLinksActive ? "training-link-active" : "")} onFocus={this.activateTrainingLinks} onBlur={this.deactivateTrainingLinksBlur} onMouseOver={this.activateTrainingLinks} onMouseOut={this.deactivateTrainingLinksMouse} to="/firesafety">Fire safety</IndexLink>
						<a className={"disabled-a training-link-trigger " + (this.state.trainingLinksActive ? "training-link-active" : "")} onFocus={this.activateTrainingLinks} onBlur={this.deactivateTrainingLinksBlur} onMouseOver={this.activateTrainingLinks} onMouseOut={this.deactivateTrainingLinksMouse}>General safety</a>
					</div>
					<IndexLink to="/gallery">Gallery</IndexLink>
					{/*<IndexLink to="/advice">Advice</IndexLink>*/}
				</div>
			</nav>
		);
	}
}



// WEBPACK FOOTER //
// ./js/components/Global/Navbar.jsx